import React, { useRef, useState, useEffect } from "react";
import "./Slider.scss";

const Slider = ({ items }) => {
    const sliderRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);

    const checkArrows = () => {
        if (!sliderRef.current) return;
        const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
        setCanScrollLeft(scrollLeft > 0);
        setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
    };

    const scroll = (direction) => {
        if (!sliderRef.current) return;
        const { scrollLeft, clientWidth } = sliderRef.current;
        const scrollAmount = direction === "left" ? scrollLeft - clientWidth : scrollLeft + clientWidth;
        sliderRef.current.scrollTo({ left: scrollAmount, behavior: "smooth" });
    };

    useEffect(() => {
        checkArrows(); // check on mount
    }, []);

    return (
        <div className="slider-event-wrapper">
            {canScrollLeft && (
                <button className="arrow left" onClick={() => scroll("left")}>
                    &#8592;
                </button>
            )}
            <div className="slider-event-container" ref={sliderRef} onScroll={checkArrows}>
                {items.map((item, index) => (
                    <img className="slider-event-item" key={index} src={item} alt={`item-${index}`} />
                ))}
            </div>
            {canScrollRight && (
                <button className="arrow right" onClick={() => scroll("right")}>
                    &#8594;
                </button>
            )}
        </div>
    );
};

export default Slider;
